function mobileHeader() {
  const $win = $(window);
  const $header = $('.header');
  $win.on('scroll', function() {
    if ($win.scrollTop() > 20) {
      $header.addClass('fixed');
    }else{
      $header.removeClass('fixed');
    }
  })

}

export default mobileHeader();



// WEBPACK FOOTER //
// ../markup/assets/js/mobile-header.js